import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCustomTranslation } from '../../hooks'
import Loading from '../components/Loading'

import { API } from '../../store/api'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '& img': {
        maxWidth: '100%',
        height: 'auto',
      },
    },
    actions: {
      textAlign: 'center',
    },
    content: {
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0),
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
  }),
)

const Agreement = () => {
  const classes = useStyles()
  const { id } = useParams()
  const [agreement, setAgreement] = useState({})
  const [agreementStatus, setAgreementStatus] = useState('')
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()

  useEffect(async () => {
    setAgreementStatus('pending')
    try {
      const res = await API.getAgreementInfo({ id })
      setAgreement(res.data)
      setAgreementStatus('fulfilled')
    } catch (error) {
      setAgreementStatus('rejected')
    }
  }, [id])

  return agreement && agreementStatus !== 'pending' && agreement?.status ? (
    <Container maxWidth="md" className={classes.root}>
      <Typography variant="h6">
        <Box fontWeight="bold" textAlign="center">
          {agreement[tB('question')]}
        </Box>
      </Typography>
      <Box className={classes.content}>
        <div dangerouslySetInnerHTML={{ __html: agreement[tB('content')] }} />
      </Box>
    </Container>
  ) : (
    <Loading title={t('tips.empty_data', { field: '$t(glossary.agreement)' })} status={agreementStatus} />
  )
}

export default Agreement
